/**
 * Component showcase route — dev only.
 * Accessible at /showcase during development; redirects to 404 in production.
 */
import { Redirect } from "expo-router";
import { ComponentShowcase } from "@/features/showcase/ComponentShowcase";

export default function ShowcaseRoute() {
  if (!__DEV__) {
    return <Redirect href="/+not-found" />;
  }
  return <ComponentShowcase />;
}
